import __request__ from "routing/request";
export function getJournalEstimate(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/migration/journalestimate", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function serialize(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/migration/serialize", null, {}, {
    "Accept": ["text/plain"]
  }, requestOptions);
}
export function status(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/migration/state", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function resetState(requestOptions) {
  return __request__("DELETE", "/plugins/org.graylog.plugins.views/migration/state", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function trigger(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.views/migration/trigger", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
